import * as React from 'react';
import DetermineFieldType from './DetermineFieldType.js';
import { FormTemplate } from './Form.styles.js';

var FormFields = function FormFields(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? [] : _ref$fields,
    _ref$nextStep = _ref.nextStep,
    nextStep = _ref$nextStep === void 0 ? null : _ref$nextStep,
    _ref$inlineButton = _ref.inlineButton,
    inlineButton = _ref$inlineButton === void 0 ? false : _ref$inlineButton,
    _ref$submitButton = _ref.submitButton,
    submitButton = _ref$submitButton === void 0 ? null : _ref$submitButton,
    _ref$radioFieldsAsBut = _ref.radioFieldsAsButtons,
    radioFieldsAsButtons = _ref$radioFieldsAsBut === void 0 ? false : _ref$radioFieldsAsBut,
    _ref$additional = _ref.additional,
    additional = _ref$additional === void 0 ? null : _ref$additional,
    _ref$smartyStreetsWeb = _ref.smartyStreetsWebsiteKey,
    smartyStreetsWebsiteKey = _ref$smartyStreetsWeb === void 0 ? true : _ref$smartyStreetsWeb;
  return /*#__PURE__*/React.createElement(FormTemplate, {
    className: className
  }, fields.map(function (field) {
    return /*#__PURE__*/React.createElement(DetermineFieldType, {
      key: field.name,
      field: field,
      inlineButton: inlineButton,
      submitButton: submitButton,
      nextStep: nextStep,
      radioFieldsAsButtons: radioFieldsAsButtons,
      smartyStreetsWebsiteKey: smartyStreetsWebsiteKey
    });
  }), additional && additional);
};
var FormFields$1 = FormFields;

export { FormFields$1 as default };
//# sourceMappingURL=FormFields.js.map
